import { BaseNumericPropertyViewModel } from './base-numeric-property-view-model';
import { PropertyViewModelInitializationInfo } from '../property-view-model-initialization-info';
import { BigNumber } from '@nts/std/types';
import type { NumericPropertyViewModelInterface } from '@nts/std/interfaces';

export class NumericPropertyViewModel<
    TModelType = BigNumber | number
> extends BaseNumericPropertyViewModel<TModelType> implements NumericPropertyViewModelInterface<TModelType> {

    override getMaskedValue(value: TModelType): string {
        if (value == null || (this.isBigNumber && typeof value !== 'number' && !BigNumber.isBigNumber(value))) {
            // TODO: we should throw an exception
            return '';
        }
        return BaseNumericPropertyViewModel.getMaskedFormattedValue(this);
    }

    constructor(
        initInfo: PropertyViewModelInitializationInfo,
    ) {
        super(initInfo, false);
        if (this.isBigNumber) {
            this.setFaultBackValue(new BigNumber(0) as TModelType);
        } else {
            this.setFaultBackValue(0 as TModelType);
        }

    }
}
